import React from "react";
const Faq = () => {
  return (
    <>
      <div className="w3l-faq-block py-5 _border-top roboto-regular" id="faq">
        <div className="container py-lg-5">
          <div className="row">
            <div className="col-lg-7">
              <section className="w3l-faq" id="faq">
                <h3 className="heading29px roboto-bold text-color-131415">Learn more from our FAQ</h3>
                <p className="heading16px roboto-regular mt20 text-color-131415">
                  Find answers to common questions and explore how we can make
                  your <br /> experience seamless and hassle-free.
                </p>
                <div className="faq-page mt-4">
                  <ul>
                    <li>
                      <input type="checkbox" />
                      <i></i>
                      <h2>Is there a setup fee for BeyondLeadz?</h2>
                      <p>
                        No, there are no setup or onboarding fees. You can start using BeyondLeadz immediately after you subscribe to a plan.
                      </p>
                    </li>
                    <li>
                      <input type="checkbox" />
                      <i></i>
                      <h2>
                        What happens if I exceed my lead limit?
                      </h2>
                      <p>
                        If you exceed your monthly lead limit, you can easily purchase additional leads through our flexible Extra Leads Pack add-on without upgrading your entire plan.
                      </p>
                    </li>
                    <li>
                      <input type="checkbox" />
                      <i></i>
                      <h2>Can I upgrade, downgrade, or cancel anytime?</h2>
                      <p>
                        Yes, BeyondLeadz plans are flexible. You can upgrade, downgrade, or cancel your subscription at any time through your account dashboard.
                      </p>
                    </li>
                    <li>
                      <input type="checkbox" />
                      <i></i>
                      <h2>Is there a free trial available?</h2>
                      <p>
                        Yes, we offer a 14-day free trial with full access to the Starter Plan features. No credit card required to start!
                      </p>
                    </li>
                  </ul>
                </div>
              </section>
            </div>
            <div className="col-lg-5 mt-lg-0 mt-sm-5 mt-4">
              <div className="banner-form-w3">
                <form>
                  <h3 className="title-style">
                    Request a <span>Quote</span>
                  </h3>
                  <p className="mt-3 text-dark" style={{ color: "#343a40" }}>
                    For service inquiries or to schedule a consultation, please contact us at &nbsp;
                    <a
                      style={{ color: "#363636" }}
                      href="mailto:contact@beyondleadz.ai"
                    >
                      contact@beyondleadz.ai
                    </a>
                  </p>

                </form>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};
export default Faq;
